<template>
<div>   
        <div style="width:350px;margin:0 auto;margin-top:100px">
            <v-form   v-model="valid" ref="form">
            <v-text-field
                type="number"
                style="width:350px;margin:0 auto;"
                label="Amount"
                :rules="rules"
                required
                v-model="amount"
                solo />
            <v-text-field
                type="number"
                style="width:350px;margin:0 auto;"
                label="Phone"
                :rules="mobileRules"
                v-model="phone"
                solo />
            <v-text-field
                type="text"
                style="width:350px;margin:0 auto;"
                label="Email"
                :rules="emailRules"
                v-model="email"
                solo />
            <div style="width:100%;float:left;height:80px;">
                <v-btn color="primary" style="width:350px;margin:0 auto;" @click="submit">Pay Now</v-btn>
            </div>
            </v-form>
        </div>

</div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            amount: "1",
            phone: "8939191794",
            email:"purusho95@gmail.com",
            config: {},
            valid: false,
            rules: [
                v => !!v || 'Amount is required',
            ],
            mobileRules: [
                v => !!v || 'Phone is required',
                v => (v && v.length == 10) || 'Number must be less than 10 digit'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
        }
    },
    computed: {
        user() {
           return this.$store.getters.user; 
        },
        razorConfig(){
            return this.$store.getters.razorConfig;
        }
    },
    methods: {
        submit() {
            const vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            vm.$refs.form.validate()
            if(!vm.valid) return;
            let {base, rid} = vm.razorConfig;
            let url = `${base}api/values?Amount=${(vm.amount * 100)}&Rid=${rid}&Secret=${vm.config.key_secret}&APIKey=${vm.config.key_id}`
            vm.$root.loader = true;
            axios(url).then((res)=>{
                vm.$root.loader = false;
                if(res.data)  {
                    vm.paynow(res.data);
                }else{
                   vm.$root.alert("Error fetching razorpay order id <br> Please contact support")                    
                }
            }).catch(({message}) => {
                vm.$root.loader = false;
                vm.$root.alert(message)
            })
        },
        paynow(order_id) {
            const vm = this;
            if(!vm.config.key_id) {
                vm.$root.alert("Unable to fetch razorpay config <br> Please contact support")                    
                return
            }
            let { description, logo,name} = vm.razorConfig
            var options = {
            "key": vm.config.key_id, // Enter the Key ID generated from the Dashboard
            "amount": vm.amount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": name,
            "description": description,
            "image": logo,
            "order_id": order_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": function (response){
                vm.process(response.razorpay_payment_id);
            },
            "prefill": {
                "name": "",
                "email": vm.email,
                "contact": vm.phone
            },
            "theme": {
                "color": "#F37254"
            }
        };
        let pay = new Razorpay(options);
        pay.open();
        },
        init() {
            const vm = this;
            vm.$root.loader = true;
            let url = 'RazorPayKey';
            let doc = {
                MobileNo: vm.user.phone,
                Password: vm.user.password,
                AuthKey: vm.user.authkey,
                Source: "json"
            };
            vm.$store.dispatch("axiospost",{
                url:url,
                data:doc,
            }).then((res) =>{
                vm.$root.loader = false;                
                if(res.data && res.data.key_id) {
                    vm.config = res.data;                    
                }else {
                   vm.$root.alert("Error fetching razorpay config <br> Please contact support")                    
                }
            }).catch(e => {
                console.log(e);
                vm.$root.loader = false;
                vm.$root.alert(e.message)
            });

        },
        notification(type,message){
            this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
            })
        },

        process(pid) {
            let vm = this;
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
             let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Source':'json',
                'PaymentMode':'RazorPay',
                'PaymentType':'Wallet',
                'TransId':pid,
                'Amount':vm.amount,
                'Mode':'Load'
            }
            vm.$root.loader = true;
            vm.$store.dispatch("axiospost",{
                    url:"Load_Balance",
                    data:doc,
            }).then(function (res) {
                    vm.$root.loader = false;
                    vm.$store.dispatch("getbalance")
                    if(res.data.Status==null) vm.notification("error","Try Agian!");
                    if(res.data.Status=="False"){
                    if(res.data.Message=="Not Authorised."){
                        window.localStorage.removeItem("user");
                        vm.$store.dispatch("getuser");
                        vm.$router.push("/account");
                        return vm.notification("error",res.data.Message);
                    }
                        return vm.notification("error",res.data.Message);
                    }
                    if(res.data.Status=="True"){
                       vm.amount = "";
                       vm.phone = "";
                       vm.email = "";
                       return vm.notification("success",res.data.Message);
                    }

            }).catch(function (error) {
                    console.log(error);
                    vm.notification("error",error);
                    vm.$root.loader = false;
            })


        }
    },
    mounted() {
        this.init();
     //       rzp1.open();
       
    }
}
</script>

<style>

</style>